// import NewsletterOverlay from './newsletterOverlay';

class Dansenett {




    constructor() {

        this.waypoints = null;
        this.prevScrollPosition = 0;
        this.$body = $('html, body');
        this.init();

        // this.newsletterOverlay = new NewsletterOverlay({
        //     enabled: window.newsletter.enabled,
        //     header: window.newsletter.header,
        //     introText: window.newsletter.introText,
        //     receiptHeader: window.newsletter.receiptHeader,
        //     receiptText: window.newsletter.receiptText,
        //     mailchimpGroups: JSON.parse(window.newsletter.mailchimpGroups),
        //     privacyUrl: window.newsletter.privacyUrl,
        //     privacyLinkText: window.newsletter.privacyLinkText,
        //     csrfEnabled: true,
        //     csrfTokenName: window.csrfTokenName,
        //     csrfTokenValue: window.csrfTokenValue,
        // });

    }

    seeMoreGallery() {
        const seeMoreButton = document.querySelector(".seeMoreImages");
        if (seeMoreButton) {
            seeMoreButton.addEventListener("click", (event) => {
                event.preventDefault(); // Prevent default button behavior.

                const hiddenImages = document.querySelectorAll("#image-gallery .hidden");

                // Check if the hidden class is present
                const isExpanded = hiddenImages.length === 0;

                if (isExpanded) {
                    // Hide all images beyond the first 4
                    const allImages = document.querySelectorAll("#image-gallery > .grid > div");
                    allImages.forEach((imageDiv, index) => {
                        if (index >= 4) {
                            imageDiv.classList.add("hidden");
                        }
                    });
                    // Update the button text to "Vis flere"
                    seeMoreButton.querySelector("span").textContent = "Vis flere";
                } else {
                    // Show all hidden images
                    hiddenImages.forEach(imageDiv => imageDiv.classList.remove("hidden"));
                    // Update the button text to "Vis færre"
                    seeMoreButton.querySelector("span").textContent = "Vis færre";
                }
            });
        }
    }

    accordionToggle() {
        const accordionTitles = document.querySelectorAll('.accordion-title');
        accordionTitles.forEach(title => {
            title.addEventListener('click', () => {
                const accordionBody = title.nextElementSibling;
                const svgPath = title.querySelector('svg path.show');

                if (accordionBody) {
                    accordionBody.classList.toggle('hidden');
                }
                if (svgPath) {
                    svgPath.classList.toggle('hidden');
                }
            });
        });
    }

    seeMoreText() {
        const seeMoreLink = document.querySelector(".seeMore");
        if (seeMoreLink) {
            seeMoreLink.addEventListener("click", (event) => {
                event.preventDefault(); // Prevent any default behavior for the button.

                const hiddenTextDiv = document.querySelector(".seeMoreText");

                if (hiddenTextDiv) {
                    // Toggle the "hidden" class on the content div.
                    hiddenTextDiv.classList.toggle("hidden");

                    // Update the button text depending on the visibility state.
                    if (hiddenTextDiv.classList.contains("hidden")) {
                        seeMoreLink.querySelector("span").textContent = "Les mer"; // Show more
                    } else {
                        seeMoreLink.querySelector("span").textContent = "Vis mindre"; // Show less
                    }
                }
            });
        }
    }

    scrollHandler() {

        let newPosition = $(window).scrollTop(),
            header = $('.site-header'),
            offset = 50;

        if (newPosition > offset) {
            header.addClass('site-header--solid');
            if (newPosition > this.prevScrollPosition + 15) {
                header.addClass('hidden');
            }
            if (newPosition < this.prevScrollPosition - 15) {
                header.removeClass('hidden');
            }
        } else {
            header.removeClass('site-header--solid hidden');
        }
        this.prevScrollPosition = newPosition;

    }


    registerEvents() {

        $(window).on('scroll', this.scrollHandler);

        $('.main-menu-toggle').on('click', function (event) {

            event.preventDefault();
            let $header = $('.site-header'),
                $btn = $(this),
                isOpen = $header.hasClass('open-navigation');

            if (isOpen) {
                $btn.html('Meny');
                $header.removeClass('open-navigation');
            } else {
                $btn.html($btn.data('close'));
                $header.addClass('open-navigation');
            }


        });

        $('.to-the-top-link button').on('click', event => {
            event.preventDefault();
            this.$body.animate({
                scrollTop: -50
            }, {
                duration: 1000
            })
        });

        $('.scroll-down-button').on('click', event => {
            event.preventDefault();
            this.$body.animate({
                scrollTop: $('.site-introduction').innerHeight()
            }, {
                duration: 500
            })
        });

    }


    performanceBubble() {

        const bubble = $('.performance-bubble');
        const link = $('.performance-bubble__link');
        const targetId = link.attr('href');
        const target = $(targetId);

        if (!bubble[0]) {
            return;
        }

        link.on('click', event => {

            event.preventDefault();

            let newPosition = Math.floor(target.offset().top);

            if (newPosition > $(window).scrollTop()) {
                this.$body.animate({
                    scrollTop: newPosition
                }, {
                    duration: 1000
                })
            }

        });

        window.addEventListener('scroll', e => {

            if (window.pageYOffset > target.offset().top) {
                bubble[0].classList.add('performance-bubble--retired');
            } else {
                bubble[0].classList.remove('performance-bubble--retired');
            }

        });

    }


    initImageGallery() {

        if ($('.flickity-container').length === 0) {
            return;
        }

        const initFlickity = function () {
            setTimeout(function () {
                let flkty = new Flickity('.flickity-container', {
                    contain: true,
                    accessibility: true,
                    percentPosition: false,
                    pageDots: false,
                    setGallerySize: false,
                    imagesLoaded: true,
                    cellAlign: 'left',
                    arrowShape: {
                        x0: 0,
                        x1: 50, y1: 50,
                        x2: 60, y2: 40,
                        x3: 20
                    }
                });
            }, 250);
        }

        $('.flickity-container').imagesLoaded(initFlickity);

    }


    initWaypoints() {

        this.waypoints = $('.fade-in').waypoint({
            handler: function (direction) {
                if (direction === 'down') {
                    $(this.element).addClass('visible');
                } else {
                    $(this.element).removeClass('visible');
                }
            },
            offset: '90%'
        });

    }


    init() {
        this.registerEvents();
        this.initImageGallery();
        this.initWaypoints();
        this.performanceBubble();
        this.seeMoreGallery();
        this.accordionToggle();
        this.seeMoreText();

    }


}
const app = new Dansenett();

